export const APP_DOMAIN = "myvitae.ai";
export const APP_URL = `https://${APP_DOMAIN}`;
export const APP_URL_WWW = `https://www.${APP_DOMAIN}`;
